<template>
  <transition name="fade-notification" v-cloak>
    <component
      v-bind="attrs"
      v-on="events"
      class="notification full-width is-radiusless mb-0"
      :class="notificationClass || 'has-background-pink has-text-white'"
      v-if="showNotification"
    >
      <div class="container" :class="{ 'pl-0': isFullButton }">
        <button v-if="!isFullButton" class="delete" @click="close()">
          <span class="is-sr-only">Delete Notifications</span>
        </button>
        <div ref="content">
          <slot />
        </div>
      </div>
      <a
        v-if="hasButton"
        :href="buttonData.url"
        :target="buttonData.external ? '_blank' : '_self'"
        @click="thisHref"
        :class="[{ button: buttonData.button }, buttonData.class]"
      >
        {{ buttonData.label }}
      </a>
    </component>
  </transition>
</template>

<script>
export default {
  name: "HeaderNotification",
  props: {
    id: {
      type: String,
    },
    isFullButton: {
      type: Boolean,
      default: false,
    },
    notificationClass: {
      type: String,
      default: "",
    },
    buttonData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      showNotification: false,
    };
  },
  updated() {
    if (this.showNotification && this.isFullButton) {
      const content = this.$refs["content"];
      const text = content.innerHTML;
      content.innerHTML = this.clearTags(text);
    }
  },
  computed: {
    events() {
      return this.isFullButton
        ? {
            click: this.thisHref,
          }
        : {};
    },
    attrs() {
      return this.isFullButton
        ? {
            is: "a",
            target: this.buttonData.external ? "_blank" : "_self",
            href: this.buttonData.url,
          }
        : { is: "div" };
    },
    hasButton() {
      return !this.isFullButton && this.buttonData && this.buttonData.url;
    },
    cookieName() {
      return `acc-notification-${this.id}`;
    },
  },
  methods: {
    close() {
      this.showNotification = false;

      if (this.id) {
        const expiration = new Date();
        expiration.setFullYear(expiration.getFullYear() + 1);

        this.$setCookie(this.cookieName, "", expiration);
      }

      //  Wait for animation before removing
      setTimeout(() => {
        this.$destroy();
        this.$el.remove();
      }, 250);
    },
    clearTags(text) {
      const newText = text.replace(/<a[^>]*>|<\/a>/g, "");
      return newText;
    },
    thisHref(e) {
      e.preventDefault();
      this.close();
      window.open(e.target.href, e.target.target);
    },
  },
  mounted() {
    if (!this.id) {
      console.warn("No Id supplied for notification");
      return;
    }

    if (this.$getCookie(this.cookieName) !== null) {
      this.close();
    } else {
      this.showNotification = true;
    }
  },
};
</script>
